<template>
    <footer class="Footer">
        <div class="container">
            <div class="Footer__content">
                <img class="Footer__photo show-mobile" v-if="broker.photo" :src="broker.photo" alt="photo">
                <LogoIcon class="hide-mobile" />
                <div class="Footer__info">
                    <a class="Footer__phone" :href="`tel:${broker.phone}`">{{ broker.phone }}</a>
                    <img class="Footer__photo hide-mobile" v-if="broker.photo" :src="broker.photo" alt="photo">
                    <div class="Footer__photo__placeholder hide-mobile" v-if="!broker.photo"></div>
                    <div class="Footer__person">
                        <div class="Footer__name">{{ broker.name }}</div>
                        <div class="Footer__position">{{ broker.position }}</div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import LogoIcon from '@/assets/image/logo/logo_white.svg?inline'

export default {
    name: "Footer",
    components: {
        LogoIcon,
    },
    computed: {
        broker() {
            return this.$store.state.broker;
        }
    },
}
</script>

<style lang="scss">
.Footer {
  margin: 40px 0;
  background-color: $primary;
  color: $white;

  @include mobile {
    margin-bottom: 0;
    margin-top: 32px;
  }

  &__content {
    position: relative;
    display: flex;
    align-items: center;
    height: 72px;

    @include mobile {
      height: auto;
      min-height: 140px;
      padding: 24px 0;
    }
  }

  &__info {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;

    @include mobile {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &__phone {
    font-size: 16px;
    font-weight: 500;

    @include mobile {
      margin-bottom: 8px;
    }
  }

  &__person {
    display: flex;
    flex-direction: column;
  }

  &__name {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-transform: uppercase;

    @include mobile {
      font-size: 14px;
    }
  }

  &__position {

  }

  &__photo {
    height: 104px;
    width: 104px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
    margin: 0 24px;

    @include mobile {
      margin: 0 16px;
    }
  }

    &__photo__placeholder {
        height: 104px;
        width: 104px;

        @include mobile {
            margin: 0 16px;
        }
    }
}
</style>